import React from 'react';
import { VStack, Box, Center, HStack, Image as NativeImage } from 'native-base';
import { Caption } from '~/shared/Typography';
import { useGeneralStyles } from '~/shared/styles';
import { SpIcon } from '~/shared/Icon';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { Logo2xl } from '~/shared/Image';
import { useI18n, useSpringBigStore } from '@springbig/shared';

type AuthTemplateProps = {
    body: any;
};

export const AuthTemplate = ({
    body,
}: AuthTemplateProps) => {

    const { merchantName, tendlcLogoSrc } = useSpringBigStore();
    const gStyle = useGeneralStyles();
    const { t } = useI18n();

    return (
        <Box
            w={"clamp(320px, 100vw, 480px)"}
            minH={"100vh"}
            backgroundColor={gStyle.button_background}
            overflowY={"auto"}
            mx={"auto"}
            flex={1}
        >
            <HStack
                px={4}
                pb="8px"
                pt="12px"
                justifyContent={"space-between"}
                backgroundColor={gStyle.button_background}
            >
                <VStack backgroundColor={gStyle.button_background} space={'1px'}>
                    {merchantName && merchantName !== 'null' && (
                        <Caption fontSize="18px" color={gStyle.button_text} fontWeight="light" lineHeight={'1em'}>
                            {t('authTemplate.welcome',[merchantName])}
                        </Caption>
                    )}
                    <Caption fontSize="18px" color={gStyle.button_text} bold lineHeight={'1em'}>
                        {t('authTemplate.log_in')}
                    </Caption>
                </VStack>
                <SpIcon icon={faLock} color={"white"} size={38} />
            </HStack>
            <VStack
                px={8}
                flex={1}
                backgroundColor={gStyle.screen_background}
                borderTopRadius={"30px"}
                space={4}
            >
                <Center mt={4}>
                    {tendlcLogoSrc ? 
                        <NativeImage 
                            resizeMode="contain"
                            w={160}
                            h={160}
                            src={tendlcLogoSrc} 
                        /> : 
                        <></>
                    }
                </Center>
                {body}
            </VStack>
        </Box>
    );
};
